import api from '@/api'
import lodash from 'lodash'

export default function (entity) {
  // console.log('baseEntity : ', entity)
  const controller = {
    createOne: () => ({
      entity,
      author: '',
      type: '',
      meta: [],
      date: new Date(),
      last_updated: new Date()
    }),
    updateControlFields: (content, context) => controller.updateLastUpdated(lodash.extend(content, {entity, author: context.rootState.user.data._id})),
    updateLastUpdated: (content) => lodash.extend(content, {last_updated: new Date()})
  }

  function base () {
    return {
      namespaced: true,
      state: {
        list: [],
        query: {selector: { entity }, limit: 9999}
      },
      mutations: {
        update (state, content) {
          var o = lodash.find(state.list, {_id: content._id})
          lodash.extend(o, content)
        },
        clear (state) {
          state.list = []
        }
      },
      actions: {
        async load (context, query, flagForce) {
          context.commit('clear')
          context.state.query = lodash.extend(context.state.query, query || {})
          const q = JSON.parse(JSON.stringify(context.state.query))
          q.selector = flagForce ? q.selector : lodash.extend(q.selector, { entity })
          const res = await api.postBIZ('/api/content/find', q)
          context.state.list = res.data
          return context.state.list
        },
        async create (context, {content, attachments}) {
          controller.updateControlFields(content, context)
          content.date = content.date || new Date()
          var res = entity !== 'staff' ? await api.putBIZ('/api/content', [{content}]) : await api.putBIZ('/api/content/join', {content})
          if (res.data.length < 1) { return }
          const {data: [{id, rev}]} = res
          lodash.extend(content, {_id: id, _rev: rev})
          for (var i = 0; i < (attachments || []).length; i++) {
            await context.dispatch('uploadAttachment', {content, attachment: attachments[i]})
          }
          await context.dispatch('load')
        },
        async delete (context, content) {
          const uri = encodeURIComponent(`${content._id}?rev=${content._rev}`)
          await api.deleteBIZ(`/api/content?uri=${uri}`)
        },
        async updateAndSave (context, content) {
          controller.updateControlFields(content, context)
          const res = await api.putBIZ('/api/content', {uri: content._id, content})
          content._rev = res.data._rev
          context.commit('update', content)
        },
        async uploadAttachment (context, {content, attachment}) {
          const query = encodeURIComponent(`${content._id}/${attachment.name}?rev=${content._rev}`)
          const fd = new FormData()
          fd.append('file', attachment)
          const {data: {rev}} = await api.putBIZ(`/api/content/attachment?uri=${query}`, fd)
          content._rev = rev
        },
        async deleteAttachment (context, {content, name}) {
          const query = encodeURIComponent(`${content._id}/${name}?rev=${content._rev}`)
          const {data: {rev}} = await api.deleteBIZ(`/api/content/attachment?uri=${query}`)
          content._rev = rev
        },
        async downloadAttachment (context, {content, name}) {
          const query = encodeURIComponent(`${content._id}/${name}`)
          await api.downloadBIZ(`/api/content/attachment?uri=${query}`, {params: {filename: name}}, 'GET')
        },
        async getAttachment (context, {content, name}) {
          const query = encodeURIComponent(`${content._id}/${name}`)
          const res = await api.request(api.host_biz, `/api/content/attachment?uri=${query}`, {method: 'GET', responseType: 'blob'})
          return res
        }
      }
    }
  }

  return base()
}



// WEBPACK FOOTER //
// ./src/store/baseEntity.js